<ng-container *ngIf="!preview_state">
    <div class="designer-container m-0  primary-bg">
        <div class="header-wrapper primary-bg"> 
            <div class="header-col-1">

                <div class="custom-search">
                    <img src="assets/settings/search-small.svg">
                    <input class="border-dark-bottom" type="search" id="input" placeholder="Type to search here" [(ngModel)]="searchCustomerList"
                        (click)="$event.stopPropagation()">
                </div>
            </div>
            <!-- studio Top Menu is loaded as metadata -->
            <div class="header-col-2">
                <div class="add-new-service-provider submit">
                    <!-- + Dashboard -->
                    <img src="assets/Plus-icon-vector-14.svg" alt="+">
                    <p class="bolder-text content-m radius-s white-text ">Service Provider</p>
                </div>
 

                <div class="add-new-customer submit" (click)="addNewCustomer()" hasPermission [hasPermissionModule]="sharedService.moduleNames.organization" [hasPermissionMode]="'Add'">
                    <!-- + Widget -->
                    <img src="assets/Plus-icon-vector-14.svg" alt="+">
                    <p class="bolder-text content-m radius-s white-text ">Add Customer</p>
                </div>
            </div>
 
        </div>
        <div class="body-wrapper p-3 white-bg">
            <div class="body-top pb-3">
                <div class="body-top-col-1">
                    <img src="assets/settings/left-arrow.svg"
                        [ngClass]="settingsVarService.organization_pages.presentPage | disableAction:settingsVarService.organization_pages.length:-1"
                        (click)="pagination_click('left')">
                    <p class="content-m secondary-text">{{settingsVarService.organization_pages.presentPage}} of
                        {{settingsVarService.organization_pages.length >0 ?
                        settingsVarService.organization_pages.length:'1'}} </p>
                    <img src="assets/settings/right-arrow.svg"
                        [ngClass]="settingsVarService.organization_pages.presentPage | disableAction:settingsVarService.organization_pages.length:1"
                        (click)="pagination_click('right')">
                </div>

                <div class="body-top-col-2 content-m bold-text label-text" [formGroup]="pagination">
                    <ng-container *ngFor="let page of metaData.commonData.pagination | keyvalue">
                         <p class="content-m black-text lighter-text">{{page.key}}</p>
                        <div class="pagination-col2-1-1" #origin>
                            <app-overlay-select [formControl]="settingsVarService.organizationPagination"
                                [data]="page.value" [origin]="origin" [style]="{'font-size':'12px'}">
                            </app-overlay-select>
                        </div>
                    </ng-container>
                </div>
            </div>
            <div class="body-bottom ml-3">
                <!-- <ng-container>
                    <div class="body-bottom-spinner">
                        <mat-spinner class="spinner" diameter=20></mat-spinner>
                    </div>
                </ng-container> -->
                <table *ngIf="settingsVarService.organization_list.length">
                    <thead>
                        <tr >
                            <ng-container *ngFor="let column of settingsVarService.organizationTableHeader">
                                <th>{{column.disp}}</th>
                            </ng-container>
                        </tr>
                    </thead>
                    <tbody>
                        <!-- <tr (click)="changeCustomer(customer, $event)" *ngFor="let customer of settingsVarService.organization_list, let i=index" id="tab{{i}}" -->
                        <tr *ngFor="let customer of settingsVarService.organization_list|searchFilter: searchCustomerList, let i=index"
                            id="tab{{i}}" [ngClass]="customer.isCurrent ? 'disable' : 'enable'">
                            <ng-container *ngFor="let column of settingsVarService.organizationTableHeader ">
                                <td *ngIf="column.value != 'edit_data';else hoverData" [tooltip]="column.value != 'edit_data'?customer[column.value]:''"> {{customer[column.value]}}</td>
                                <ng-template #hoverData>
                                    <td *ngIf="column.value == 'edit_data' ">
                                        <div class="edit-data">
                                            <img class="change-customer-img tooltip-enable" src="assets/settings/changeCustomer.svg"
                                                (click)="changeCustomer(customer, $event)" tooltip="Change Customer" />
                                            <img class="edit-customer-img tooltip-enable" src="assets/settings/edit-row.svg"
                                                (click)="editCustomer(customer, $event)" tooltip="Edit Customer" />
                                        </div>
                                    </td>
                                </ng-template>
                            </ng-container>
                        </tr>
                    </tbody>
                </table>
                <div class="studio-list-nodata" *ngIf="!settingsVarService.organization_list.length">
                    <div class="nodata-img">
                        <img src="assets/designer/empty-data.svg">
                    </div>
                    <div>
                        <!-- <p>{{errorhandlestudiolist.status ? errorhandlestudiolist.errmsg:nodata}}</p> -->
                    </div>
                </div>
            </div>
        </div>
    </div>
</ng-container>
<ng-container *ngIf="mat_spinner_CustomerState">
    <div class="body-edit-spinner">
        <mat-spinner class="spinner" diameter=20></mat-spinner>
    </div>
</ng-container>
<ng-container *ngIf="preview_state">
    <app-designer-build *ngIf="(designType=='Dashboard' || designType=='Report')" [mode]="mode_tochild"
        [editDetails]="previewDetails_tochild" [designType]="designType" [createdDt]='createdDt'
        [widgetsList_toChild]="widgetDetails" [templates]="templatesDetails"
        (cancelDesigner)=cancelDesigner_fromChild($event)>
    </app-designer-build>
    <app-preview *ngIf="designType=='preview'" class="previewContainer pl-2" [previewLayout]="previewDetails_tochild"
        [designType]=designType (cancelPreview)=cancelPreview_fromChild()>
    </app-preview>
    <ng-container *ngIf="designType=='Widget'">
        <widget-builder (cancel_widgetbuilder)="cancelWidget_fromChild($event)"
            (spinnercontrol_parent)=controlSpinner($event)>
        </widget-builder>
    </ng-container>
</ng-container>

<!-- <ng-container>
    <div class="body-edit-spinner">
        <mat-spinner class="spinner" diameter=20></mat-spinner>
    </div>
</ng-container> -->

<ng-container *ngIf="mat_spinner_organizationList_state">
    <div class="body-edit-spinner">
        <mat-spinner class="spinner" diameter=20></mat-spinner>
    </div>
</ng-container>



<ng-container *ngIf="sharedService.mat_spinner_login_state">
    <div class="spinner-background">
        <div class="inner-spinner">
            <mat-spinner class="spinner" diameter="40"></mat-spinner>
            <p>Loading...</p>
        </div>
    </div>
</ng-container>